<template>
  <app-modal name="rule-list-modal"  :esc-to-close="false" :title="title" :click-to-close="false" :submit-on-enter="false" @before-open="beforeOpen" hide-footer width="50%">
    <div class="rule-list">
      <h5 class="text-center" v-if="!rules || rules.length === 0">
        {{$t('rule.ruleIsEmpty')}}
      </h5>
      <app-search-box
        :placeholder="$t('rule.searchPlaceholder')"
        v-model="filterText"
        @search="search"
        @clear="clear"
        size="sm"
      ></app-search-box>
      <div :class="{'duplicate': ruleTargetCount[rule.target] > 1 || invalidRule[rule.id] }" class="rule-item" v-for="rule in rules" :key="rule.id">

        <div class="content">
          <div class="name">{{rule.name}}</div>
          <div class="description" v-html="displayRuleCondition(rule)">
          </div>
          <div v-if="ruleTargetCount[rule.target] > 1 || invalidRule[rule.id]" class="description red">
            {{$t('rule.invalidRuleMsg')}}
          </div>
        </div>
        <div class="actions">
          <a class="" @click="onClickExe(rule)" href="javascript:">
            <i class="fal fa-play"></i>
          </a>
          <a class="" @click="onClickEdit(rule)" href="javascript:">
            <i class="fal fa-pencil-alt"></i>
          </a>
          <a  class="" @click="onClickDelete(rule)" href="javascript:">
            <i class="fal fa-trash"></i>
          </a>
        </div>
      </div>
    </div>
  </app-modal>
</template>

<script>
import Vue from 'vue';
import AppModal from '@/components/app-modal/';
import AppTable from '@/components/app-table/';
import AppSearchBox from '@/components/app-search-box/';
import RuleProxy from '@/store/proxies/rule-proxy';
import { getDirectoryOptions } from '@/utils/directory';
import { getTagOptions } from '@/utils/tag';

export default {
  name: 'RuleList',
  components: {
    AppTable,
    AppModal,
    AppSearchBox,
  },
  props: {},
  data() {
    return {
      title: this.$t('rule.ruleList'),
      rules: [],
      originRules: [],
      directories: getDirectoryOptions(),
      tags: getTagOptions(),
      filterText: '',
      ruleTargetCount: {},
      invalidRule: {},
    };
  },
  computed: {
  },
  created() {
    this.$bus.on('update-rule-success', this.onUpdateRuleSuccess);
  },
  beforeDestroy() {
    this.$bus.off('update-rule-success', this.onUpdateRuleSuccess);
  },
  methods: {
    search(searchText) {
      // eslint-disable-next-line no-useless-escape
      const standalizeSearchText = text => text.replace(/[-:\[\];\(\)]/g, '').replace(/\s+/g, ' ');
      this.rules = this.originRules.filter((i) => {
        const ruleConditions = i.conditions.map(c => c.value);
        return new RegExp(standalizeSearchText(searchText), 'i').test(standalizeSearchText(i.name))
            || ruleConditions.some(c => !!c && typeof c === 'string' && new RegExp(standalizeSearchText(searchText), 'i').test(standalizeSearchText(c)));
      },
    );
    },
    clear() {
      this.rules = [
        ...this.originRules,
      ];
    },
    onUpdateRuleSuccess(updatedRule) {
      const index = this.rules.findIndex(r => r.id === updatedRule.id);
      Vue.set(this.rules, index, updatedRule);
      this.checkInvalidRule();
    },
    onClickExe(rule) {
      new RuleProxy().execRule(rule.id);
    },
    onClickEdit(rule) {
      this.$modal.show('create-rule-modal', { model: rule });
    },
    onClickDelete(rule) {
      this.$modal.show('dialog', {
        title: this.$t('rule.deleleRule'),
        text: this.$t('rule.deleleRuleConfirmMsg'),
        okText: this.$t('app.delete'),
        okClass: 'btn btn-danger btn-sm',
        onOk: () => {
          new RuleProxy().deleteRule(rule.id).then(() => {
            this.rules = this.rules.filter(r => r.id !== rule.id);
          });
        },
      });
    },
    getDirectoryName(dirId) {
      const indx = this.directories.findIndex(d => d.value === dirId);
      return indx > -1 ? this.directories[indx].text : dirId;
    },
    getTagName(tags) {
      const result = [];
      tags.forEach((tagId) => {
        const indx = this.tags.findIndex(d => d.value === tagId);
        if (indx > -1) {
          result.push(this.tags[indx].text);
        }
      });
      return result.join('  ,  ');
    },
    displayRuleCondition(rule) {
      const displayTags = rule.tags.length > 0 ? `</br> ${this.$t('rule.setTag')} <strong>${this.getTagName(rule.tags)}</strong>` : '';
      const displayDir = rule.target ? `</br> ${this.$t('rule.moveToDir')} <strong>${this.getDirectoryName(rule.target)}</strong>` : '';
      return `${rule.conditions.map(con => `( ${this.$t(`constant.INVOICE_RULES.${con.key}`)} : ${con.value} )`).join(' & ')} ${displayDir} ${displayTags} `;
    },
    checkInvalidRule() {
      const vm = this;
      vm.ruleTargetCount = {};
      this.rules.forEach((r) => {
        if (r.target) {
          if (vm.ruleTargetCount[r.target]) {
            vm.ruleTargetCount[r.target]++;
          } else {
            vm.ruleTargetCount[r.target] = 1;
          }
        }
        // check invalid rule
        if (r.tags.length === 0) {
          if (!r.target || this.directories.findIndex(d => d.value === r.target) === -1) { vm.invalidRule[r.id] = true; }
        }
      });
    },
    beforeOpen() {
      new RuleProxy().getRules().then((res) => {
        this.rules = res.map(rl => ({
          id: rl.id,
          ...rl.structure,
        }));
        this.originRules = [
          ...this.rules,
        ];
        this.checkInvalidRule();
      });
    },
  },
};
</script>
<style scoped>
.rule-item{
  border: 1px solid #dedede;
  border-radius: 4px;
  padding: .5rem;
  margin: 1rem 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.duplicate {
  border: 1px solid red;
}
.rule-item .name {
  font-size: 14px;
  font-weight: bold;
}

.actions {
  min-width: 100px;
}

.actions i.fa {
  font-size: 18px;

}
.actions a {
  padding: .5rem;
}
.actions a:hover {
  background: #dedede;
  border-radius: 4px;
}

.description {
  font-size: 12px;
  font-style: italic;
}
</style>



// WEBPACK FOOTER //
// src/portal-components/rule/rule-list.vue